import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./Select.css";

export default function Select({ children, onChange, className, disabled }) {
  return (
    <select
      className={classNames(styles.root, className)}
      onChange={onChange}
      disabled={disabled}
    >
      {children}
    </select>
  );
}

Select.propTypes = {
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func,
};
